import { Component, input } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import LocalizationConstants from "src/app/constants/localization-constants";

@Component({
  selector: "app-back-button",
  templateUrl: "./back-button.component.html",
  styleUrls: ["./back-button.component.scss"],
  imports: [MatIconModule, TranslateModule],
  standalone: true,
})
export class BackButtonComponent {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  title = input(LocalizationConstants.BUTTON_BACK);
  navigationPath = input<string>(null);

  navigateBack() {
    // TODO: accept optional parameter or change default button text if we want to use this component in other places

    if (this.navigationPath() === null) {
      window.history.length > 1 ? window.history.back() : this.router.navigate(["/"]);
    } else {
      this.router.navigate([this.navigationPath()], { relativeTo: this.route });
    }
  }
}
